import ParagraphComponent from "../components/paragraph";
import {getFormattedPrice} from "../utils/get-formatted-price";
import {RenderPosition, render} from "../utils/render";

export default class PriceController {
  constructor({className = ``, price, oldPrice}) {
    this._className = className;
    this._price = price;
    this._oldPrice = oldPrice;
  }

  render(container) {
    this._renderOldPrice(container);
    this._renderPrice(container);
  }

  _renderOldPrice(container) {
    if (!this._oldPrice) {
      return;
    }
    const formattedOldPrice = getFormattedPrice(this._oldPrice);

    const oldPriceComponent = new ParagraphComponent({
      className: `${this._className}__itemPriceOld price price--old`,
      text: formattedOldPrice,
    });

    render(container, oldPriceComponent.getElement(), RenderPosition.BEFOREEND);
  }

  _renderPrice(container) {
    const discountClass = (+this._oldPrice && +this._oldPrice > +this._price)
      ? `price--discount`
      : ``;

    const formattedPrice = getFormattedPrice(this._price);

    const priceComponent = new ParagraphComponent({
      className: `${this._className}__itemPrice price ${discountClass}`,
      text: formattedPrice,
    });

    render(container, priceComponent.getElement(), RenderPosition.BEFOREEND);
  }
}
